<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :withFooter="false"
    width="calc(100% - 250px)"
    :confirm-working="isWorking"
    @close="close"
    @confirm="confirm">
    <div style="width: calc(100% - 32px); position: sticky;padding: 12px 16px; top: 0px; left: 0; z-index: 999; background-color: white">
      <div style="display: flex;background: #e4ecfe;padding: 20px">
        <div style="width: 60px;">
          <div class="home_title" v-if="info">
            <el-image v-if="info.fullCoverImage" style="width: 50px; height: 50px;border-radius: 50%;margin-right: 10px" :src="info.fullCoverImage"
                      :preview-src-list="[info.fullCoverImage]">
            </el-image>
            <el-image v-else style="width: 50px; height: 50px;border-radius: 50%;margin-right: 10px" src="avatar/man.png" >
            </el-image>
          </div>
        </div>
        <div style="width: calc(100% - 60px);">
          <div class="home_title" v-if="info">
            <div class="left">
              <span class="m10">昵称：{{info.nickName }}  <span class="ml10 bluebtn" :title="'姓名：'+(info.name||'未设置姓名')"  >({{(info.name||'未设置姓名') }})</span></span>
              <el-tag type="primary" class="mr10 tag1">发单方</el-tag>
              <el-tag type="success" class="mr10 tag1" v-if="info.workerIdentity == 2 || info.driverIdentity == 2 || info.chefIdentity == 2">接单方</el-tag>
            </div>
          </div>
          <div class="remark" v-if="info">
            <el-button  class="bluebtn" icon="el-icon-phone" title="手机号"> {{info.telephone||'未设置' }}</el-button>
            <el-button  class="yellowbtn" icon="el-icon-star-on"  title="平均评分"> {{info.score||'0' }}分</el-button>
            <el-button  class="redbtn" icon="el-icon-coin"  title="账号余额(元）"> {{(info.amount||0).toFixed(2)}}元</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="renzheng"   v-for="item in tableData2">
          <div class="info" >
              <span class="m10" v-if="item.type ==0">用工认证</span>
              <span class="m10" v-if="item.type ==1">货运认证</span>
              <span class="m10" v-if="item.type ==2">供餐认证</span>
              <el-tag type="primary" class="ml10 tag2" v-if="item.auditStatus == 1">申请中</el-tag>
              <el-tag type="success" class="ml10 tag2" v-if="item.auditStatus == 2">认证通过</el-tag>
              <el-tag type="danger" class="ml10 tag2" v-if="item.auditStatus == 3">认证失败</el-tag>
          </div>
          <div class="detail" >
            <div class="line">
              <span class="label"> 认证类型：</span> <span class="txt">{{item.authType == 0? '个人':'企业' }}</span>
              <span class="label"> 联系人：</span> <span class="txt">{{item.linkName || '' }}</span>
              <span class="label"> 联系方式：</span> <span class="txt">{{item.telephone || '' }}</span>
              <span class="label"> 申请时间：</span> <span class="txt">{{item.createTime || '' }}</span>
            </div>
            <template v-if="item.authType ==1">
              <div class="line">
                <span class="label">单位位置：</span><span class="txt">{{item.location || '' }}</span>
                <span class="label">单位名称：</span><span class="txt">{{item.companyName || '' }}</span>
              </div>
              <div class="line"> <span class="label">认证资料：</span> <span v-if="!item.imgList || item.imgList.length==0" class="txt">无</span> </div>
            </template>
            <template v-else>
              <div class="line">
                <span class="label">接单位置：</span><span class="txt">{{item.location || '' }}</span>
              </div>
              <div class="line">
                <span class="label">身份信息：</span> <span v-if="!item.imgList || item.imgList.length==0" class="txt">无</span>
              </div>
            </template>
              <div class="line" v-if="item.imgList && item.imgList.length>0">
                <div v-for="info in item.imgList" style="display: inline-block">
                  <el-image v-if="info" style="width: 50px; height: 50px; margin-right: 10px" :src="info"
                            :preview-src-list="[info]">
                  </el-image>
                </div>
              </div>
            <div class="line" v-if="item.auditStatus == 3 || item.auditStatus == 2" :style="'background-color: '+(item.auditStatus==2?'#eff8ea':'rgb(253 226 226)')+';padding: 20px'">
              <span class="label"> 审核人：</span> <span class="txt">{{item.editorName}} </span><span class="label">{{item.auditTime || '' }} </span>
              <div  style="margin-top: 20px"> <span class="label">  审核信息：</span> <span class="txt">{{item.auditRemark || '' }}</span></div>
          </div>
          </div>
        </div>
      <div class="line bottom"  v-if="tableData2&& tableData2.length>0 && tableData2[0].auditStatus == 1 && containPermissions(['business:identityinfo:audit'])"   >
        <el-form :model="form" ref="formCheck" :rules="rules">
          <el-form-item label="认证审核说明" style="font-size: 14px" prop="auditRemark">
            <el-input  type="textarea" rows="5" v-model="form.auditRemark" placeholder="请输入认证审核备注" v-trim/>
          </el-form-item>
        </el-form>
        <el-button @click="checkDo(2)" :loading="dealing" type="primary" class="status-red">同意</el-button>
        <el-button  @click="checkDo(3)" :loading="dealing" type="danger" >拒绝</el-button>
      </div>
    </div>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/common/GlobalWindow'
import BaseOpera from '@/components/base/BaseOpera'
import { getById } from '@/api/business/member'
import { fetchList as renzhengList, audit } from '@/api/business/identityInfo'
export default {
  components: {
    GlobalWindow
  },
  extends: BaseOpera,
  data () {
    return {
      dealing: false,
      form: {
        id: null,
        auditRemark: null
      },
      rules: { auditRemark: [{ required: true, message: '请输入认证审核备注' }] },
      id: '',
      memberId: '',
      visible: false,
      activeTabs: 0,
      type: 0,
      info: {},
      tableData2: [],
      loading: false
    }
  },
  methods: {
    open (title, row) {
      this.title = title
      this.visible = true
      this.tableData2 = []
      this.id = row.id
      this.form.id = this.id
      this.form.auditRemark =null
      this.memberId = row.memberId
      this.getData()
    },
    getData () {
      getById(this.memberId)
        .then(res => {
          this.info = res
          this.visible = true
          this.getRenzhengList()
        })
    },
    close () {

    },
    checkDo (status) {
      console.log(this.$refs.formCheck.length)
      this.$refs.formCheck.validate((valid) => {
        if (!valid) {
          return
        }
        this.$dialog.actionConfirm('您确认【' + (status === 3 ? '拒绝' : '同意') + '】该申请吗？', '操作确认')
          .then(() => {
            this.dealing = true
            audit({
              id: this.id,
              auditStatus: status,
              auditRemark: this.form.auditRemark
            })
              .then(res => {
                this.$tip.apiSuccess('操作成功')
                this.getData()
                this.$emit('success')
              })
              .catch(e => {
                this.$tip.apiFailed(e)
              })
              .finally(() => {
                this.dealing = false
              })
          })
      })
    },
    getRenzhengList () {
      this.loading = true
      renzhengList({
        page: 1,
        capacity: 1000000,
        model: {
          memberId: this.memberId || -1,
          id: this.id || -1
        }
      }).then(res => {
        this.loading = false
        this.tableData2 = res.records
      }).catch(e => {
        this.$tip.apiFailed(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';
.bottom{
  text-align: center;
  display: block;
  height: auto;
  background-color: #e4ecfe;
  width: calc(100% - 32px);
  z-index: 999;
  padding: 16px;
}
.renzheng{
  margin: 0px 0px 30px 20px;
  width: calc(100% - 60px);
  .detail{
    font-size: 14px;
    .label{
      color: #8c939d;
    }
    .txt{
      margin-right: 30px;
    }
    .line{
      margin-top: 15px;
    }
  }
  .ml10{
    margin-left: 10px;
  }
  .info{
    font-size: 14px;
    font-weight: bold;
  }
  .tag2{
    font-size: 12px;
  }
}
.home_title {
  .mr10{
    margin-right: 10px;
  }
  .m10{
    margin: 10px;
  }
  .bluebtn{
    color: #2985f7;
  }
  .tag1{
    border-radius: 10px;
    font-size: 10px;
    padding: 0px 15px;
    height: 24px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    font-weight: 500;
    font-size: 14px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    .status {
      padding: 0 6px;
      height: 22px;
      line-height: 22px;
      border-radius: 2px;
      border: 1px solid #00BA92;
      color: #00BA92;
      font-weight: 400;
      font-size: 12px;
      color: #00BA92;
    }
  }
}
.tab{
  width: 20%;
}
.remark {
  //background: #E8EBF7;
  border-radius: 2px;
  font-size: 14px;
  margin: 10px 10px 0px -10px;
  button{
    border: none;
    cursor: default;
    margin-right: 20px;
    background: #e4ecfe;
  }
}
.bluebtn{
  font-weight: bold;
  color: #2985f7;
}

.redbtn{
  font-weight: bold;
  color: #ff1b1b;
}
.yellowbtn{
  font-weight: bold;
  color: #fc9d20;
}

.tabs {
  border-bottom: 1px solid #DFE2E8;
  display: flex;
  margin-bottom: 20px;
  .tab {
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    color: #666666;
    margin-right: 30px;
    cursor: pointer;
  }

  .active {
    font-weight: 500;
    color: $primary-color;
    border-bottom: 2px solid $primary-color;
  }
}

.main {
  padding: 12px 16px;
  .title {
    font-weight: 500;
    font-size: 12px;
    color: $primary-color;
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label{
    font-size: 12px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    /*background: #F7F7F7;*/
    border-radius: 2px;
    /*padding: 15px 20px;*/
    margin-bottom: 20px;

    .item {
      font-size: 14px;
      width: 25%;
      margin-bottom: 16px;

      .la {
        color: #7f7f7f;
        margin-bottom: 10px;
      }
    }
  }
}

/deep/ .window__body {
  padding: 0px !important;
}
</style>
